import { render, staticRenderFns } from "./PageNotificationRedirect.vue?vue&type=template&id=504c67a5"
import script from "./PageNotificationRedirect.vue?vue&type=script&lang=js"
export * from "./PageNotificationRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports